var _path, _path2, _path3, _rect, _rect2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidatorExit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25879 29.7285C7.25879 27.9336 8.71386 26.4785 10.5088 26.4785H10.6444C12.4393 26.4785 13.8944 27.9336 13.8944 29.7285V31.4912C13.8944 33.2862 12.4393 34.7412 10.6444 34.7412H10.5088C8.71387 34.7412 7.25879 33.2862 7.25879 31.4912V29.7285Z",
    fill: "#475467",
    stroke: "#1D2939",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56348 4.50831C1.56348 2.71338 3.01855 1.2583 4.81348 1.2583H16.3389C18.1338 1.2583 19.5889 2.71337 19.5889 4.5083V24.9829C19.5889 26.7778 18.1338 28.2329 16.3389 28.2329H4.81347C3.01855 28.2329 1.56348 26.7778 1.56348 24.9829V4.50831Z",
    fill: "#F9F9FB",
    stroke: "#1D2939",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25391 5.43936C3.25391 4.16086 4.43701 3.21063 5.6854 3.48646L14.6355 5.46401C15.4878 5.65234 16.1196 6.37171 16.1963 7.24125L17.7062 24.3668C17.8093 25.5361 16.8878 26.5424 15.7139 26.5424H5.25391C4.14934 26.5424 3.25391 25.647 3.25391 24.5424V5.43936Z",
    fill: "#667085"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.2526,
    y: 22.6609,
    width: 4.89835,
    height: 24.0934,
    rx: 2.44917,
    transform: "rotate(-107.369 25.2526 22.6609)",
    fill: "#F9F9FB",
    stroke: "#1D2939",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3779,
    y: 21.7046,
    width: 2.04233,
    height: 20.4233,
    rx: 1.02117,
    transform: "rotate(-107.369 27.3779 21.7046)",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0893 25.3138L23.0893 14.7842C23.0896 14.7843 23.0899 14.7844 23.0902 14.7844C23.5722 14.8752 24.2048 15.0516 24.8295 15.39C25.4506 15.7264 26.0559 16.218 26.5082 16.9424C26.9588 17.664 27.2842 18.6585 27.2842 20.0444C27.2842 21.4487 26.958 22.4517 26.5076 23.1756C26.0557 23.9019 25.4517 24.3905 24.8326 24.7222C24.2095 25.056 23.5783 25.2264 23.0973 25.3123C23.0946 25.3128 23.0919 25.3133 23.0893 25.3138Z",
    fill: "#667085",
    stroke: "#1D2939",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidatorExit);
export default __webpack_public_path__ + "static/media/validator_exit.c450eb3d78f45db3aa3097f985ff29e7.svg";
export { ForwardRef as ReactComponent };